import { useState } from 'react'
import { getAttachmentUploadUrl } from '@/lib/getAttachmentUploadUrl'
import { putAttachment } from '@/lib/putAttachment'

export interface UseUploadAttachmentOptions {
  questionnaireId: string | undefined
  authToken: string
}

export interface UseQuestionnaireSessionReturn {
  loading: boolean
  error: string | undefined
  uploadAttachment: (file: File) => Promise<void>
  attachmentReference: string | undefined
}

export function useUploadAttachment({
  questionnaireId,
  authToken
}: UseUploadAttachmentOptions): UseQuestionnaireSessionReturn {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | undefined>()

  const [attachmentReference, setAttachmentReference] = useState<string>()

  async function uploadAttachment(file: File) {
    try {
      setLoading(true)
      if (!questionnaireId) throw new Error('Questionnaire ID is required')
      const uploadUrlResponse = await getAttachmentUploadUrl(
        questionnaireId,
        authToken,
        file
      )
      await putAttachment(uploadUrlResponse.presignedPutUrl, file)
      setAttachmentReference(uploadUrlResponse.url)
    } catch (e) {
      setError(e as Error)
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    error: error?.message,
    uploadAttachment,
    attachmentReference
  }
}
